import React from 'react';
import PrivateHeader from "../../Components/PrivateHeader";

const PrivatePage = ({children}) => <div>
    <PrivateHeader/>
    {children}
</div>;

export default PrivatePage;